import React ,{useState} from 'react'
import axios from "axios";
import { APIURL,TZ } from "../../../Global";
import './profile.css'
import {Button ,Modal } from 'react-bootstrap';
import { useAlert } from 'react-alert';

function YearUpdate(props) {
    const alert = useAlert()
    const[year ,setYear] =useState(props.regYear !== '' ? props.regYear : '')
    const id = props.id1
    const [error,setError]=useState({
        year:''
       });

    const handleChange=(e)=>{
        e.preventDefault();
        const val=e.target.value;  
        const key=e.target.name;
      
          if(key==='year'){
            setYear(val)
          }  
        }

        const  validate = () => {
          //let input = email;
          let errors = {};
          let isValid = true;
    
          if (year==="" ) {
            isValid = false;
            errors["year"] = "Enter Registered Year";
          }
      
          setError(currentstate=>({
            ...currentstate,...errors
          }))
      
          return isValid;
      }

      const handleContinue =async(e) => {
        e.preventDefault();
    
        if( validate() ){
          submitAddress()
        }
      }

        const submitAddress = (e) =>{
            const tokenString= sessionStorage.getItem('usertoken');
             
             let str= tokenString.replace(/["]+/g, '') 
          
             const data = {
                registeration_year : year
             }
          
             axios.put(`${APIURL}/api/v1/doctor/medical-profile-update-view/${id}/` ,data, { headers: {
          
              "Authorization" : 'Token '+str  }})
            .then(res=>{
            
                  
              if(res.data.status==="success"){
                
                alert.success("Updated successfully")
                props.handle()
                setYear()              
            
              }else{
                alert.error("Error in submission. Try again!") 
              }
            
            })
            .catch(err=>{
              alert.error("Error in submission. Try again!") 

            })
          
          }

    return (
        <div>
            <div className="item"><input className="form-control" type="number" value={year} min="1940" max="2050" maxLength="150" name="year" placeholder="Registration Year" onChange={handleChange}/>

                {error.year ? <div className="error-validation-msg"> {error.year}</div> : null}

            </div>
            <br/>
            <div className="form-button">
                <button  onClick={handleContinue} className="btn btn-primary btn-col" >Update Registration Year</button>
            </div>
         </div>
    )
}

export default YearUpdate
